/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_DeleteInputs */



/**
* | output |
* | --- |
* | "Delete template" |
*
* @param {Settings_Template_DeleteInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_delete = /** @type {((inputs?: Settings_Template_DeleteInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_DeleteInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Template verwijderen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer le modèle")
	return /** @type {LocalizedString} */ ("Delete template")
});